/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/SheetForecastNotificationRecipient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./SheetForecastNotificationRecipient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SheetForecastNotificationReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.SheetForecastNotificationRecipient);
  }
}(this, function(ApiClient, SheetForecastNotificationRecipient) {
  'use strict';




  /**
   * The SheetForecastNotificationReport model module.
   * @module model/SheetForecastNotificationReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>SheetForecastNotificationReport</code>.
   * @alias module:model/SheetForecastNotificationReport
   * @class
   */
  var exports = function() {
    var _this = this;







  };

  /**
   * Constructs a <code>SheetForecastNotificationReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SheetForecastNotificationReport} obj Optional instance to populate.
   * @return {module:model/SheetForecastNotificationReport} The populated <code>SheetForecastNotificationReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Recipients')) {
        obj['Recipients'] = ApiClient.convertToType(data['Recipients'], [SheetForecastNotificationRecipient]);
      }
      if (data.hasOwnProperty('ForecastID')) {
        obj['ForecastID'] = ApiClient.convertToType(data['ForecastID'], 'Integer');
      }
      if (data.hasOwnProperty('Message')) {
        obj['Message'] = ApiClient.convertToType(data['Message'], 'String');
      }
      if (data.hasOwnProperty('GenerateSheetContent')) {
        obj['GenerateSheetContent'] = ApiClient.convertToType(data['GenerateSheetContent'], 'Boolean');
      }
      if (data.hasOwnProperty('Sent')) {
        obj['Sent'] = ApiClient.convertToType(data['Sent'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/SheetForecastNotificationRecipient>} Recipients
   */
  exports.prototype['Recipients'] = undefined;
  /**
   * @member {Integer} ForecastID
   * @default 0
   */
  exports.prototype['ForecastID'] = 0;
  /**
   * @member {String} Message
   * @default ''
   */
  exports.prototype['Message'] = '';
  /**
   * @member {Boolean} GenerateSheetContent
   * @default false
   */
  exports.prototype['GenerateSheetContent'] = false;
  /**
   * @member {Date} Sent
   */
  exports.prototype['Sent'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


